import { useFilter } from '@features/table-filter';

import { useGetFormsQuery } from '../api';
import { IFormFilter } from '../model/types';

export const useForms = () => {
  const filter = useFilter<IFormFilter>();
  const { currentFilter } = filter;

  const {
    data: forms,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetFormsQuery(currentFilter.toString());

  return {
    forms,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
